/*
Post用スライダー
*/
var Swiper = require('Swiper');

var PostSlider = function($element){
    this.$element = $element
    this.elements = [];
    this.sw;
    this.swiperParam;
    this.init();
}

PostSlider.prototype = {
    init: function(){
        var self = this;

        require('fluidbox');
        this.$element.each(function() { self.swiper($(this)); });
    },

    setParam: function($element) {
        this.swiperParam = {
            nextButton: $element.find('.swiper-button-next'),
            prevButton: $element.find('.swiper-button-prev'),
            slidesPerView: 'auto',
            paginationClickable: true,
            preloadImages: false,
            lazyLoading: true,
            lazyLoadingInPrevNext: true,
            spaceBetween: 10,
            loop: true,
            loopAdditionalSlides: 1,
        }

        if ($('body').hasClass('smp') || $('body').hasClass('tb')) {
            this.swiperParam['centeredSlides'] = true;
        } else {
            var paddingBefore = ($('.l-post-inner').innerWidth() - $('.l-post-inner').width()) / 2;
            var offsetBefore = $('.l-post-inner').width() + paddingBefore - $('.post-body').width();
            this.swiperParam['slidesOffsetBefore'] = offsetBefore;

            var buttonMarginLeft = offsetBefore + (($('.post-body').width() - $('.swiper-button').width()) / 2);
            $('.swiper-button').css('margin-left', buttonMarginLeft + 'px');
        }
    },

    swiper: function($element) {
        var self = this;

        if (self.elements.indexOf($element.get(0)) != -1) {
            return
        }

        self.elements.push($element.get(0));
        self.setParam($element);
        this.sw = new Swiper($element, self.swiperParam);

        $element.find('a').on('click', function() {
            return false;
        });

        var assignFluidBox = function($anchor) {
            $anchor.on('openstart.fluidbox', function() {
                $(this).parents('.swiper-wrapper').css('z-index', '1009').parent('.swiper-container').css('z-index', '1008');
                $('#js-globalHeader').addClass('animation').addClass('hide');
                ga('send', 'pageview', location.pathname + '/slide');

            }).on('closeend.fluidbox', function() {
                if ($('.fluidbox--opened').length == 0) {
                    $(this).parents('.swiper-wrapper').css('z-index', '1').parent('.swiper-container').css('z-index', '1');
                    $('#js-globalHeader').removeClass('hide').one('transitionend', function() { $(this).removeClass('animation'); });
                }

            }).fluidbox({ immediateOpen: true });
        };

        this.sw.on('lazyImageReady', function(swiper, slide, image) {
            var $slide = $(slide);
            var $image = $(image);
            var $anchor = $slide.children('a');

            $image.siblings('div').remove();

            if ($slide.hasClass('swiper-slide-active')) {
                $anchor.off('.slide');
                assignFluidBox($anchor);

            } else if ($slide.hasClass('swiper-slide-prev')) {
                $anchor.off('.slide').on('click.slide', function() {
                    swiper.slidePrev();
                    return false;
                });

            } else if ($slide.hasClass('swiper-slide-next')) {
                $anchor.off('.slide').on('click.slide', function() {
                    swiper.slideNext();
                    return false;
                });

            } else {
                $anchor.off('.slide');
            }
        });

        this.sw.on('transitionEnd', function(swiper) {
            var $wrapper = $(swiper.wrapper);
            var $total = $(swiper.wrapper).siblings('.swiper-button').find('.swiper-counter span.total-count');
            var totalIndex = $total.text();
            var currentIndex = (swiper.activeIndex % totalIndex) + 1;
            var isOpen = $('.fluidbox--opened').length > 0 ? true : false;

            ga('send', 'pageview', location.pathname + '/slide');
            $total.prev('span').text(currentIndex);
            $wrapper.find('.swiper-slide').each(function() {
                var $slide = $(this);
                var $anchor = $slide.children('a');

                if ($slide.hasClass('swiper-slide-active') && $anchor.find('.swiper-lazy-loaded').length > 0) {
                    $anchor.off('.slide').one('ready.fluidbox', function() {
                        if (isOpen) {
                            $(this).one('open.myfluidbox', function() {
                                $(this).trigger('click.fluidbox');
                            });
                        }
                    });
                    assignFluidBox($anchor);

                } else if ($slide.hasClass('swiper-slide-prev')) {
                    var slidePrev = function() {
                        $(this).parent().next().children('a').trigger('open.myfluidbox');
                        $(this).trigger('destroy.fluidbox').off('.fluidbox').off('.slide').on('click.slide', function() {
                            swiper.slidePrev();
                            return false;
                        });
                    };

                    if (isOpen) {
                        $anchor.trigger('close.fluidbox').on('closeend.fluidbox', slidePrev);
                    } else {
                        $anchor.each(slidePrev);
                    }

                } else if ($slide.hasClass('swiper-slide-next')) {
                    var slideNext = function() {
                        $(this).parent().prev().children('a').trigger('open.myfluidbox');
                        $(this).trigger('destroy.fluidbox').off('.fluidbox').off('.slide').on('click.slide', function() {
                            swiper.slideNext();
                            return false;
                        });
                    };

                    if (isOpen) {
                        $anchor.trigger('close.fluidbox').on('closeend.fluidbox', slideNext);
                    } else {
                        $anchor.each(slideNext);
                    }

                } else {
                    $slide.children('a').off('.slide');
                }
            });
        });
    },

    reset: function($element) {
        var self = this;
        self.$element = $element;
        self.$element.each(function() { self.swiper($(this)); });
    }
};
module.exports = PostSlider;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/PostSlider.js
 **/